import * as THREE from "three";
import { Scene } from 'three';
import ZPosition from "../Core/Enums/ZPosition";

const InitializeScene = (scene: Scene): void => {
  // Scene, Lighting
  scene.background = new THREE.Color(0x000000);
  scene.add(new THREE.AmbientLight(0xffffff, 1));

  // World Map
  const worldMapBaseGeometry = new THREE.PlaneGeometry(100, 100);
  const worldMapBaseTexture = new THREE.TextureLoader().load('./assets/map/world-map-base.png');
  worldMapBaseTexture.magFilter = THREE.NearestFilter;
  const worldMapBaseMaterial = new THREE.MeshBasicMaterial({ map: worldMapBaseTexture, transparent: true });
  const worldMapBase = new THREE.Mesh(worldMapBaseGeometry, worldMapBaseMaterial);
  worldMapBase.position.x = 0;
  worldMapBase.position.y = 50;
  worldMapBase.position.z = ZPosition.WorldMapBase;
  scene.add(worldMapBase);

  const worldMapStaticObjectsGeometry = new THREE.PlaneGeometry(100, 100);
  const worldMapStaticObjectsTexture = new THREE.TextureLoader().load('./assets/map/world-map-objects.png');
  worldMapStaticObjectsTexture.magFilter = THREE.NearestFilter;
  const worldMapStaticObjectsMaterial = new THREE.MeshBasicMaterial({ map: worldMapStaticObjectsTexture, transparent: true });
  const worldMapStaticObjects = new THREE.Mesh(worldMapStaticObjectsGeometry, worldMapStaticObjectsMaterial);
  worldMapStaticObjects.position.x = 0;
  worldMapStaticObjects.position.y = 50;
  worldMapStaticObjects.position.z = ZPosition.WorldMapStaticObject;
  scene.add(worldMapStaticObjects);

  const worldMapAboveGeometry = new THREE.PlaneGeometry(100, 100);
  const worldMapAboveTexture = new THREE.TextureLoader().load('./assets/map/world-map-above.png');
  worldMapAboveTexture.magFilter = THREE.NearestFilter;
  const worldMapAboveMaterial = new THREE.MeshBasicMaterial({ map: worldMapAboveTexture, transparent: true });
  const worldMapAbove = new THREE.Mesh(worldMapAboveGeometry, worldMapAboveMaterial);
  worldMapAbove.position.x = 0;
  worldMapAbove.position.y = 50;
  worldMapAbove.position.z = ZPosition.WorldMapAbove;
  scene.add(worldMapAbove);
}

export default InitializeScene;
